import $ from 'jquery';

$(() => {
    const subPumId = document.getElementById('popmake-id-subcription');
    const isHomePage = document.getElementById('is-homepage');
    const enabledSubsPopup = document.getElementById('enable-subscription-popup');
    const newsLetterPopupHeader = $('.newsletter-popup');
    
    var popupShown = false;

    if(isHomePage && isHomePage.value && subPumId){
        PUM.preventOpen('#pum-' + subPumId.value);  
    }

    if(enabledSubsPopup && enabledSubsPopup.value == ''){
        PUM.preventOpen('#pum-' + subPumId.value);  
    }

    $(newsLetterPopupHeader).on('click', function(){
        popupShown = true;
    });
    
    function isElementInViewport(el) {
        var rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }

    function openPopupWhenVisible() {
        if (popupShown) {
            return;
        }

        var triggerDiv = document.getElementById('feature-products-section');

        if (triggerDiv) {
            var triggerPosition = triggerDiv.getBoundingClientRect();
    
            var triggerPositionThreshold = window.innerHeight * 0.3;
    
            if (triggerPosition.top <= triggerPositionThreshold) {
                if (subPumId) {
                    PUM.open('#popmake-' + subPumId.value);
                    popupShown = true;
                    window.removeEventListener('scroll', openPopupWhenVisible);
                }
            }
        }
    }

    openPopupWhenVisible();

    window.addEventListener('scroll', openPopupWhenVisible);

    if ($('.woocommerce.columns-3').length > 0) {
        if ($('.product').length === 0) {
            var pageTitle = $('.page-header h1').text();
            var noProductHtml = `<div class="pt-5">
                <h1 class="mb-10 text-3xl font-extrabold font-sohneBreit lg:text-7xl md:px-0 block">${pageTitle}</h1>
                <p class="woocommerce-result-count pb-10">
                    No products found.
                </p>
            </div>`;
      $('.woocommerce').append(noProductHtml);
    }
  }

  if ($('.checkout.woocommerce-checkout #order_review').length > 0) {
    $('.checkout.woocommerce-checkout #order_review').prepend(
      '<h3>Your Order</h3>'
    );

    const paymentDiv = document.getElementById('payment');

    paymentDiv.insertAdjacentHTML(
      'beforebegin',
      '<div class="checkout-divider"></div><h3>Payment Info</h3>'
    );
  }

  var scrollToNextSectionElements = document.querySelectorAll(
    '.scroll-to-next-section'
  );

  scrollToNextSectionElements.forEach(function (element) {
    element.addEventListener('click', function () {
      var currentSection = element.closest('section');
      var nextSection = currentSection.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  const age_verification = getCookie('avc');

  if (!age_verification) {
    $('#age-verification').removeClass('hidden');
    $('#age-verification').css('opacity', '1');
    $('body').css('overflow', 'hidden');
    window.scrollTo(0, 0);
  }

  $('#age-verification-yes').on('click', function () {
    setCookie('avc', '1', 30);
    $('#age-verification').css('opacity', '0');
    $('#age-verification').addClass('hidden');
    $('body').css('overflow', 'auto');
  });

  $('#age-verification-no').on('click', function () {
    $('#age-verification-text').html(
      'Sorry! <br>You are not old enough to view the site...'
    );
    $('.age-verification-buttons').hide();
  });

  window.onscroll = function () {
    const sidePane = document.querySelector('.js-side-brand-scroll');

    if (sidePane) {
      let winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      let height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      let scrolled = (winScroll / height) * 100;
      const transform = 'translateY(' + scrolled / 3 + '%) rotate(-180deg)';
      sidePane.style.transform = transform;
      sidePane.style.webkitTransform = transform;
      sidePane.style.msTransform = transform;
    }
  };

  if ($(window).width() <= 768 || navigator.userAgent.match(/iPad/i) != null) {
    var prevScrollpos = window.pageYOffset;
    window.onscroll = function () {
      var currentScrollPos = window.pageYOffset;
      // var mainsection = $('.mainsection ').offset().top

      var mainsectionElement = $('.mainsection');
      if (mainsectionElement.length > 0) {
        var mainsection = mainsectionElement.offset().top;
        // Rest of your code that uses mainsectionTop

        if (
          prevScrollpos < currentScrollPos &&
          $(window).scrollTop() >= mainsection
        ) {
          document.getElementById('js-navbar').style.top = '-83px';
        } else {
          document.getElementById('js-navbar').style.top = '0';
        }
        prevScrollpos = currentScrollPos;
      } else {
        console.log('.mainsection element not found.');
      }
    };
  }

  var flag = 0;
  let flag_search = 0;
  // header search
  $('.header_search_btn').on('click', function () {
    showSearchBar(true);

    if (flag == 1) {
      $('.get_filter').trigger('click');
    } else {
      $('#js-search-field').trigger('focus');
    }
  });

  function showSearchBar(show) {
    if (show) {
      $('.header_search').stop().slideToggle(200);
    } else {
      $('.header_search').slideUp();
    }
  }

  $('.close_search').on('click', function () {
    showSearchBar(false);
  });

  $(window).on('load', function () {
    if ($('.header_search').hasClass('js-add-padding')) {
      $('.main-content').css(
        'paddingTop',
        $('header').innerHeight() + $('.header_search').innerHeight()
      );
      flag_search = 1;
    }
  });

  $(document).on('click', '#js-clear-search-btn', function (e) {
    e.preventDefault();
    window.location.href = '/';
  });

  function toggleMainContentPaddingTop(the_flag) {
    if (the_flag == 0) {
      $('.main-content').css(
        'paddingTop',
        $('header').innerHeight() + $('.header_search').innerHeight()
      );
      flag_search = 1;
    } else {
      flag_search = 0;
      $('.main-content').css('paddingTop', $('header').innerHeight());
    }
  }

  $(document).on('click', '.cart-link', function () {
    $('.cart-box').fadeToggle('200');
  });
  $(document).on('click', '.cart-close-link', function () {
    $('.cart-box').fadeOut('200');
  });

  // hamburger dd

  function humbergerToggle() {}

  $('.menu-btn').on('click', function () {
    $('body').removeAttr('style');
    $('body').toggleClass('overflow-hidden');
    $('.menu-btn').stop().toggleClass('open');
    $('.hamburger_menu').toggleClass('pointer-events-none opacity-0');

    if (window.location.pathname !== '/faq/') {
      if ($('.menu-btn').hasClass('open')) {
        $('header').css('background', 'black');
      } else {
        $('header').css('background', '');
      }
    }
  });

  var flag = 0;
  $('.show_detail').on('click', function () {
    const thisBtn = $(this);
    $(this)
      .parent()
      .next()
      .stop()
      .fadeToggle(100, 'linear', function () {
        if ($(window).width() > 767) {
          if ($(thisBtn).hasClass('active')) {
            $(thisBtn).text('EXPAND DESCRIPTION +');
            $(thisBtn).removeClass('active');
          } else {
            $(thisBtn).text('CLOSE DESCRIPTION ×');
            $(thisBtn).addClass('active');
          }
        }
      });
  });

  // if ($('.main-content').hasClass('aboutpage')) {
  //     $('html').addClass('lg:pl-14');
  //     $('header').addClass('lg:ml-14');
  // }

  /* product tab */
  $(document).on('click', '.product-tab-list', function () {
    $('.product-tab-list').removeClass('active');

    $('.product-tab-content').hide();
    var activeTab = $(this).attr('href');
    $(this).addClass('active');
    $(activeTab).fadeIn();

    // const index = $(this).data('index')
    // const totalImageCtr = $('#js-total-image-ctr').val()

    // const length = parseInt(index) / parseInt(totalImageCtr) * 100

    // $('.js-indicator-vertical').css('height', length + '%')
    // $('.js-indicator-horizontal').css('width', length + '%')

    return false;
  });

  /* notify popup */
  $('.notify-button').on('click', function () {
    $('.notify-popup').fadeIn();
  });
  $('.notify-popup-bg').on('click', function () {
    $('.notify-popup').fadeOut();
  });

  /* product detail accordion */
  $(document).on('click', '.accordion-heading', function (j) {
    const head = $(this);
    const isLink = $(j.target).is('a[href]');
    const faq = $(this).hasClass('faq');
    var dropDown = $(this)
      .closest('.accordion-card')
      .find('.accordion-content:first');
    $(this)
      .closest('.accordion-wrap')
      .find('.accordion-content')
      .not(dropDown)
      .slideUp();

    if (isLink) {
      return;
    }

    if ($(this).hasClass('active')) {
      if (faq) {
        $(this)
          .removeClass('active')
          .find('.accordion-caret-rotator')
          .addClass('rotate-90');
      } else {
        $(this)
          .removeClass('active')
          .children('.accordion-icon')
          .css('transform', 'rotate(0)');
      }
    } else {
      if (faq) {
        $(this)
          .addClass('active')
          .find('.accordion-caret-rotator')
          .removeClass('rotate-90');
      } else {
        $(this)
          .closest('.accordion-wrap')
          .find('.accordion-heading.active')
          .removeClass('active')
          .children('.accordion-icon')
          .css('transform', 'rotate(0)');
        $(this)
          .addClass('active')
          .children('.accordion-icon')
          .css('transform', 'rotate(45deg)');
      }
    }

    const border = faq ? 'border-b-0' : 'lg:border-b-0';
    const hasBorderB0 = head.hasClass(border);
    const last = $(this).data('last');

    if (hasBorderB0 && last == '1') {
      head.removeClass(border);
    }

    dropDown.stop(false, true).slideToggle('fast', 'swing', function () {
      if (!hasBorderB0 && last == '1') {
        head.addClass(border);
      } else if (last == '0') {
        $.each($('.accordion-heading'), function (index, item) {
          const data = $(item).data('last');
          if (data == '1' && !$(item).hasClass(border)) {
            $(item).addClass(border);
          }
        });
      }

      setTimeout(() => {
        const headerHeight = $('header').outerHeight();
        const targetPosition = head.offset().top;
        const windowHeight = $(window).height();
        const scrollPosition = targetPosition - headerHeight;

        if (
          scrollPosition > $(window).scrollTop() + windowHeight ||
          scrollPosition < $(window).scrollTop()
        ) {
          $('html, body').animate(
            {
              scrollTop: targetPosition - headerHeight,
            },
            'fast'
          );
        }
      }, 200);
    });

    j.preventDefault();
  });

  /* color radio mark */
  $(".color-label input:checked[type='radio']")
    .parents('label')
    .css('border-color', '#fd562c');
  $(".color-label input[type='radio']").on('click', function () {
    $(".color-label input:checked[type='radio']")
      .parents('label')
      .css('border-color', '#fd562c');
    $(".color-label input:not(:checked)[type='radio']")
      .parents('label')
      .css('border-color', 'rgba(255, 255, 255, .3)');
  });

  $(document).on('click', '#add-to-cart-btn', function () {
    console.log('add to cart..');
    const hasVariation = $('#hasVariation').val();

    if (
      hasVariation == 1 &&
      typeof $('input[name="color-radio"]:checked').val() == 'undefined'
    ) {
      $('.js-select-variation-first').removeClass('hidden');
    } else {
      let product_id = $("input[name='product_id']").val();
      let quantity = $("input[name='quantity']").val();
      let max_quantity = $("input[name='max_quantity']").val();
      let stock_status = $("input[name='stock_status']").val();
      let manage_stock = $("input[name='manage_stock']").val();
      let variation_id = $("input[name='variation_id']").val();
      $('#add-to-cart-btn').prop('disabled', true);
      $('#add-to-cart-btn').removeAttr('style');
      $('#add-to-cart-btn').text('ADDING TO CART');

      console.log('product_id', product_id);
      updateCartCount(product_id);
      $.ajax({
        type: 'POST',
        url: '/?wc-ajax=add_to_cart',
        data: {
          product_sku: '',
          product_id: variation_id != '' ? variation_id : product_id,
          quantity: quantity,
        },
        dataType: 'json',
        success: function (res) {
          $('#add-to-cart-btn').text('ADDED TO CART');
          const stockLimit = parseInt(max_quantity - quantity) <= 0;

          loadFloatingCart();
          setTimeout(function () {
            let stockText = stockLimit
              ? 'Out of Stock'
              : 'Only ' + parseInt(max_quantity - quantity) + ' in Stock';

            if (stock_status != 'outofstock' || manage_stock) {
              if (manage_stock) {
                if (stockLimit) {
                  $('#add-to-cart-btn').text('OUT OF STOCK');
                  $('#add-to-cart-btn').prop('disabled', true);
                  $('#add-to-cart-btn').removeClass(
                    'hover:bg-black hover:text-ecru-white-500'
                  );
                } else {
                  $('#add-to-cart-btn').text('ADD TO CART');
                  $('#add-to-cart-btn').prop('disabled', false);
                }
              } else {
                $('#add-to-cart-btn').text('ADD TO CART');
                $('#add-to-cart-btn').prop('disabled', false);
                stockText = 'In Stock';
              }
            } else {
              $('#add-to-cart-btn').text('OUT OF STOCK');
              $('#add-to-cart-btn').prop('disabled', true);
              $('#add-to-cart-btn').removeClass(
                'hover:bg-black hover:text-ecru-white-500'
              );
            }
            $('.js-single-product-stock-left').text(stockText);

            if ($(window).width() <= 768) {
              $('#add-to-cart-btn').css({
                'background-color': '#f0f1e5',
                color: 'black',
              });
            }
          }, 3000);
        },
        error: function (e) {
          console.log(e);
          $('#add-to-cart-btn').prop('disabled', false);
        },
      });
    }
  });
  function updateCartCount(product_id) {
    // Check for JsFloatingCart element continuously using setInterval
    const checkJsFloatingCartInterval = setInterval(function () {
      console.log('check floating cart..');
      const floatingCart = document.getElementById('JsfloatingCart');
      if (floatingCart) {
        // JsFloatingCart element is found, so we can clear the interval
        clearInterval(checkJsFloatingCartInterval);

        // Get all elements with data-id attribute inside the container
        const elementsWithDataId = floatingCart.querySelectorAll('[data-id]');

        // Create a set to store unique data-ids
        const uniqueDataIds = new Set();

        // Loop through each element and add its data-id to the set if it is not empty or undefined
        elementsWithDataId.forEach((element) => {
          const dataId = element.getAttribute('data-id');
          if (dataId && dataId.trim() !== '') {
            uniqueDataIds.add(Number(dataId));
          }
        });
        // add the id of the product that was added to cart
        uniqueDataIds.add(Number(product_id));
        console.log('uniqueDataIds', uniqueDataIds);

        // Get the count of unique data-ids
        const uniqueCount = uniqueDataIds.size;

        // Get the cart counter
        const cartCounter = document.getElementById('floating-cart-counter');
        cartCounter.innerHTML = 'Cart (' + uniqueCount + ')';

        console.log('set cart count: ', uniqueCount);
      } else {
        // JsFloatingCart element is not found yet, do nothing for this iteration
        console.log('JsFloatingCart not found yet...');
      }
    }, 100); // Interval time in milliseconds (100ms in this example)
  }

  $(document).on('click', '.js-add-to-cart-shop', function (e) {
    const variation_id = $(this).data('variation');
    const product_id = $(this).data('product_id');
    const button = $(this);

    button.prop('disabled', true);
    button.removeAttr('style');
    button.text('Adding to Cart');

    $.ajax({
      type: 'POST',
      url: '/?wc-ajax=add_to_cart',
      data: {
        product_sku: '',
        product_id: variation_id != '' ? variation_id : product_id,
        quantity: 1,
      },
      dataType: 'json',
      success: function (res) {
        button.text('Added to Cart');
        loadFloatingCart();
        setTimeout(function () {
          button.text('Add to Cart');
          if ($(window).width() <= 768) {
            button.css({
              'background-color': 'black',
              color: '#f0f1e5',
              'border-color': '#f0f1e5',
            });
          }
          button.prop('disabled', false);
        }, 3000);
      },
      error: function (e) {
        console.log(e);
        button.prop('disabled', false);
      },
    });
  });

  $(document).on('click', '.js-remove-cart-item-btn', function () {
    const product_id = $(this).data('id');
    const product_key = $(this).data('key');

    // toggleCartLoader()
    $('#js-confirm-modal').fadeIn(200);
    $('#js-cart-item-id').val(product_id);
    $('#js-cart-item-key').val(product_key);
  });

  $('#js-confirmed-modal').on('click', function () {
    console.log('remove product..');
    const product_id = $('#js-cart-item-id').val();
    const product_key = $('#js-cart-item-key').val();
    const update_btn = $('.js-update-cart-btn');
    hideConfirmModal();
    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'updateCartItem',
        nonce: sage.nonce,
        product_key: product_key,
        code: 'delete',
      },
      dataType: 'json',
      success: function (res) {
        $('.js-cart-item-' + product_id).fadeOut();
        if (!res.data.has_cart_items) {
          update_btn.fadeOut();
        }
        $('.js-cart-loader').addClass('hidden');
        $('#js-cart-items-container').empty();
        console.log(res.data.cart_items_html);
        $('#js-cart-items-container').html(res.data.cart_items_html);
        $('#js-cart-summary-container').html(res.data.cart_summary);
        loadFloatingCart();
      },
      error: function (e) {
        console.log(e);
      },
    });
  });

  $('#js-hide-confirm-modal').on('click', function () {
    hideConfirmModal();
  });

  function hideConfirmModal() {
    $('#js-confirm-modal').fadeOut(200);
    toggleCartLoader();
    $('#js-cart-item-id').val('');
  }

  $(document).on('click', '.js-update-cart-btn', function () {
    toggleCartLoader();
    const item_rows = $('.js-cart-item');

    const cart_data = [];
    $('.js-update-cart-btn').prop('disabled', true);
    $('.js-update-cart-btn').removeAttr('style');
    $('.js-update-cart-btn').text('Updating Cart');
    $.each(item_rows, function (index, item) {
      const product_id = $(item).data('id');
      const product_key = $(item).data('key');
      const quantity = $('#quantity-' + product_id).val();
      cart_data.push({
        product_id: product_id,
        quantity: quantity,
        product_key: product_key,
      });
    });

    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'updateCartItem',
        nonce: sage.nonce,
        cart_data: cart_data,
        code: 'update',
      },
      dataType: 'json',
      success: function (res) {
        toggleCartLoader();
        $('#js-cart-items-container').html(res.data.cart_items_html);
        $('.js-update-cart-btn').text('Updated Cart');
        $('#js-cart-summary-container').html(res.data.cart_summary);
        loadFloatingCart();
        setTimeout(function () {
          $('.js-update-cart-btn').text('Update Cart');
          if ($(window).width() <= 768) {
            $('.js-update-cart-btn').css({
              'background-color': '#f0f1e5',
              color: 'black',
            });
          }
          $('.js-update-cart-btn').prop('disabled', false);
        }, 3000);
      },
      error: function (e) {
        console.log(e);
        $('.js-update-cart-btn').prop('disabled', false);
      },
    });
  });

  // Define a simple debounce function
  function debounce(func, delay) {
    let debounceTimer;

    return function () {
      const context = this;
      const args = arguments;

      clearTimeout(debounceTimer);

      debounceTimer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  // Wrap the click handler with debounce
  // const debouncedClickHandler = debounce(function() {
  //     $(document).on('click', '.js-update-floating-cart-btn', function () {
  //         toggleCartLoader()
  //         const item_rows = $('.js-floating-cart-item')

  //         const cart_data = []
  //         $.each(item_rows, function (index, item) {
  //             const product_id = $(item).data('id')
  //             const product_key = $(item).data('key')
  //             const quantity = $('#quantity-floating-' + product_id).val()
  //             cart_data.push({
  //                 product_id: product_id,
  //                 quantity: quantity,
  //                 product_key: product_key
  //             })
  //         })

  //         console.log("cart_data", cart_data)

  //         $.ajax({
  //             type: "POST",
  //             url: sage.ajax_url,
  //             data: {
  //                 action: 'updateCartItem',
  //                 nonce: sage.nonce,
  //                 cart_data: cart_data,
  //                 code: 'update'
  //             },
  //             dataType: "json",
  //             success: function (res) {
  //                 toggleCartLoader()
  //                 $('#js-cart-items-container').html(res.data.cart_items_html)
  //                 $('#js-cart-summary-container').html(res.data.cart_summary)
  //                 $('#js-floating-subtotal').html(res.data.subtotal)

  //             },
  //             error: function (e) {
  //                 console.log(e)
  //             }
  //         })
  //     })
  // }, 500); // Specify the debounce delay (in milliseconds) here

  // Define the click handler function
  function handleFloatingCartClick() {
    toggleCartLoader();
    const item_rows = $('.js-floating-cart-item');

    const cart_data = [];
    $.each(item_rows, function (index, item) {
      const product_id = $(item).data('id');
      const product_key = $(item).data('key');
      const quantity = $('#quantity-floating-' + product_id).val();
      cart_data.push({
        product_id: product_id,
        quantity: quantity,
        product_key: product_key,
      });
    });

    console.log('cart_data', cart_data);

    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'updateCartItem',
        nonce: sage.nonce,
        cart_data: cart_data,
        code: 'update',
      },
      dataType: 'json',
      success: function (res) {
        toggleCartLoader();
        $('#js-cart-items-container').html(res.data.cart_items_html);
        $('#js-cart-summary-container').html(res.data.cart_summary);
        $('#js-floating-subtotal').html(res.data.subtotal);
      },
      error: function (e) {
        console.log(e);
      },
    });
  }

  // Attach the debounced click handler to the element
  // Wrap the click handler with debounce
  const debouncedClickHandler = debounce(handleFloatingCartClick, 300); // Specify the debounce delay (in milliseconds) here

  // Attach the debounced click handler to the element
  $(document).on(
    'click',
    '.js-update-floating-cart-btn',
    debouncedClickHandler
  );

  // $(document).on("blur", '.js-quantity-field', function () {
  //     $('.js-update-cart-btn').prop("disabled", false)
  // })

  // $(document).on("change", '.js-quantity-field-floating', function () {
  //     $('.js-update-floating-cart-btn').prop("disabled", false)
  // })

  function toggleCartLoader() {
    $('.js-cart-loader').toggleClass('hidden');
  }

  let page = 2;

  const loadMoreLatestBtn = $('#js-load-more-the-latest');
  $(loadMoreLatestBtn).on('click', function () {
    $(loadMoreLatestBtn).prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'loadLatests',
        nonce: sage.nonce,
        page: page,
      },
      dataType: 'json',
      success: function (res) {
        if (res.data.latest) {
          page++;
          $('.js-the-latest-container').append(res.data.latest);
        } else {
          $('#js-no-content-text').removeClass('hidden');
          $(loadMoreLatestBtn).addClass('hidden');
        }
        $(loadMoreLatestBtn).prop('disabled', false);
      },
      error: function (e) {
        console.log(e);
        $(loadMoreLatestBtn).prop('disabled', false);
      },
    });
  });

  const loadMoreResourcesBtn = $('#js-load-more-resources');
  $(loadMoreResourcesBtn).on('click', function () {
    $(loadMoreResourcesBtn).prop('disabled', true);
    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'loadResources',
        nonce: sage.nonce,
        page: page,
      },
      dataType: 'json',
      success: function (res) {
        console.log(res);
        if (res.data.latest) {
          page++;
          $('.js-resrouces-container').append(res.data.latest);
        } else {
          $('#js-no-content-text').removeClass('hidden');
          $(loadMoreResourcesBtn).addClass('hidden');
        }
        $(loadMoreResourcesBtn).prop('disabled', false);
      },
      error: function (e) {
        console.log(e);
        $(loadMoreResourcesBtn).prop('disabled', false);
      },
    });
  });

  $(document).on('click', '.color-radio', function () {
    if (!$('.js-select-variation-first').hasClass('hidden')) {
      $('.js-select-variation-first').addClass('hidden');
    }

    $('.js-quantity-container').removeClass('hidden');

    const id = $(this).data('id');
    const quantity = $(this).data('quantity');
    const stockStatus = $(this).data('stock-status');
    const price = $(this).data('price');
    $('#js-product-tab-' + id).trigger('click');
    $('#js-variation-id').val(id);

    console.log('quantity', parseInt(quantity));
    console.log('stockStatus', stockStatus);

    let stockText = '';
    let qty = parseInt(quantity);

    if (isNaN(qty)) {
      qty = 0;
    }

    if (stockStatus != 'outofstock') {
      if (qty == 0 && stockStatus == 'instock') {
        stockText = 'In Stock';
      } else if (qty != 0) {
        if (qty > 0 && qty < 11) {
          stockText = quantity + ' in Stock';
        }
      } else {
        stockText = 'Out of Stock';
      }
    } else {
      stockText = 'Out of Stock';
    }

    // if(isNaN(parseInt(quantity))){
    //     const stockText =
    // }

    // const stockText = parseInt(quantity) != 0 ? 'Only ' + quantity + ' in Stock' : 'Out of Stock'

    $('.js-single-product-stock-left').text(stockText);
    $('.js-single-product-price').text('$' + price);
    $('#max-quantity').val(quantity);
  });

  function validateQuantity(value, max, min = 1) {
    let str = value.toString().replace(/\b0+/g, '');
    str = str.replace(/[^0+0-9\.]/g, '');
    if (parseInt(str) > parseInt(max)) {
      str = max;
    }

    if (parseInt(str) < parseInt(min) || str == '') {
      str = min;
    }

    return str;
  }

  $(document).on('keyup', '.js-number-only', function (e) {
    const id = $(this).data('id');
    const max = $('#max-quantity-' + id).val();
    const value = $(this).val();
    let quantity = validateQuantity(value, max);
    $('#quantity-' + id).val(quantity);
  });

  $(document).on('click', '.js-adjust-quantity-btn', function () {
    const id = $(this).data('id');
    const action = $(this).data('action');
    const value = $('#quantity-' + id).val();
    const max = $('#max-quantity-' + id).val();
    let quantity = 1;
    if (action == 'inc') {
      quantity = validateQuantity(parseInt(value) + 1, max);
    } else if (action == 'dec') {
      quantity = validateQuantity(parseInt(value) - 1, max);
    }

    $('#quantity-' + id).val(quantity);

    if ($('.js-update-cart-btn')) {
      $('.js-update-cart-btn').prop('disabled', false);
    }
  });

  $(document).on('keyup', '.js-number-only-single', function (e) {
    const max = $('#max-quantity').val();
    const value = $(this).val();
    let quantity = validateQuantity(value, max);
    $('#quantity').val(quantity);
  });

  $(document).on('click', '.js-adjust-quantity-single-btn', function () {
    const action = $(this).data('action');
    const value = $('#quantity').val();
    const max = $('#max-quantity').val();
    const manageStock = $('#manage-stock').val();

    let quantity = 1;
    if (action == 'inc') {
      if (manageStock) {
        quantity = validateQuantity(parseInt(value) + 1, max);
      } else {
        quantity = parseInt(value) + 1;
      }
    } else if (action == 'dec') {
      quantity = validateQuantity(parseInt(value) - 1, max);
    }

    $('#quantity').val(quantity);

    if ($('.js-update-cart-btn')) {
      $('.js-update-cart-btn').prop('disabled', false);
    }
  });

  loadFloatingCart();
  function loadFloatingCart() {
    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'loadFloatingCart',
        nonce: sage.nonce,
      },
      dataType: 'json',
      success: function (res) {
        $('#floating-cart-counter').html(res.data.floating_cart_count_html);
        $('#js-floating-cart-container').html(res.data.floating_cart_html);
      },
      error: function (e) {
        console.log(e);
      },
    });
  }

  $(document).on('click', '.add_to_cart_button', function (e) {
    console.log('product page add to cart..');
    if (!$(this).hasClass('product_type_variable')) {
      let product_id = $(this).data('product_id');
      console.log('product_id', product_id);
      e.preventDefault();
      e.stopPropagation();

      updateCartCount(product_id);

      setTimeout(() => {
        loadFloatingCart();
      }, 2000);
    }
  });

  $('.js-countries').on('change', function () {
    const element = $(this).prop('id').split('_')[0];

    const el = $('#' + element + '_state');

    $(el).prop('disabled', true);

    const country = $(this).val();

    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'loadStates',
        country: country,
        nonce: sage.nonce,
      },
      dataType: 'json',
      success: function (res) {
        if (res.data.states) {
          $(el).prop('disabled', false);
          $(el).html('<option value="">Select state</option');
          $.each(res.data.states, function (index, item) {
            $(el).append('<option value="' + index + '">' + item + '</option>');
          });
        }
      },
      error: function (e) {
        console.log(e);
      },
    });
  });

  $('#other-recipient').on('change', function () {
    $('#js-shipping-accordion').fadeToggle(200, 'linear');
  });

  $(document).on('change', '#createaccount', function () {
    $('#js-createaccount-accordion').fadeToggle(200, 'linear');

    if ($(this).is(':checked')) {
      $('#js-payment-method-container').removeClass('hidden');
    } else {
      $('#js-payment-method-container').addClass('hidden');
    }
  });

  $('input[name="ebizcharge-use-stored-payment-info"]').on(
    'change',
    function () {
      const value = $(
        'input[name="ebizcharge-use-stored-payment-info"]:checked'
      ).val();

      $('.js-stored-payment-accordion').fadeOut(100, 'linear', function () {
        $('#js-stored-payment-' + value + '-accordion').fadeIn('200', 'linear');
      });
    }
  );

  $(document).on('submit', '#js-checkout-form', function () {
    toggleCartLoader();
    $(this).prop('disabled', true);
  });

  let lastAccordion = $('#last-accordion').val();
  let openedLastAccordion = false;
  let lastValidatedFields = '';

  function validateFields(el) {
    const fieldTarget = $(el).data('validate');
    const fields = $('#' + fieldTarget).find('.js-form-input');

    let hasError = false;
    const msgElement =
      $(el).siblings('.error-msg').length > 0
        ? $(el).siblings('.error-msg')
        : $(el).parent().siblings('.error-msg');
    msgElement.hide();

    if (
      fieldTarget != 'shipping-fields' ||
      (fieldTarget == 'shipping-fields' && $('#other-recipient').is(':checked'))
    ) {
      $.each(fields, function (index, item) {
        if (
          fieldTarget != 'shipping-fields' &&
          (($('#createaccount').length > 0 &&
            !$('#createaccount').is(':checked') &&
            ($(item).prop('name') == 'account_username' ||
              $(item).prop('name') == 'account_password')) ||
            $(
              'input[name="ebizcharge-use-stored-payment-info"]:checked'
            ).val() == 'yes')
        ) {
          // pass
        } else {
          if ($(item).prop('required') && $(item).val() == '') {
            hasError = true;
            if (!$(item).hasClass('border-red-500')) {
              $(item).addClass('border-red-500');
            }
          } else {
            $(item).removeClass('border-red-500');
          }
        }
      });
    }

    if (hasError) {
      msgElement.fadeIn(100);
    }

    return hasError;
  }

  $(document).on('click', '.js-custom-accordion-btn', function () {
    const position = $(this).data('position');

    const hasError = validateFields(this);

    if (!hasError) {
      if (typeof position != 'undefined' && position !== '') {
        $('.js-custom-accordion-item-' + position).fadeToggle(
          200,
          'linear',
          function () {
            $('.js-edit-accordion-' + position)
              .get(0)
              .scrollIntoView();
            $(
              '.js-custom-accordion-item-' + (parseInt(position) + 1)
            ).fadeToggle(200, 'linear');
            lastAccordion = parseInt(position) + 1;
          }
        );

        if (parseInt(position) + 1 == 4) {
          openedLastAccordion = true;
        }
        $('.js-edit-accordion-' + position).removeClass('hidden');

        lastValidatedFields = $(
          '.js-edit-accordion-' + (parseInt(position) + 1)
        ).data('validate');
      } else {
        $('.js-custom-accordion-btn').val('Checking Out');
        $('#place_order').trigger('click');
      }
    }
  });

  $(document).on('click', '.js-edit-accordion', function () {
    const position = $(this).data('position');

    const hasError =
      position > lastAccordion
        ? validateFields(
            $('#' + lastValidatedFields)
              .find('.js-custom-accordion-btn')
              .eq(0)
          )
        : false;

    if (!hasError) {
      if (openedLastAccordion) {
        $('.js-edit-accordion-4').removeClass('hidden');
      }

      $('.js-custom-accordion-item-' + lastAccordion).fadeToggle(
        200,
        'linear',
        function () {
          $('.js-custom-accordion-item-' + position).fadeToggle(200, 'linear');
          lastAccordion = position;
        }
      );

      lastValidatedFields = $('.js-edit-accordion-' + position).data(
        'validate'
      );
    }
  });

  $(document).on(
    'change',
    '#other-recipient, #billing_country, #billing_state, #shipping_country, #shipping_state, input[name="shipping_method"]',
    function () {
      reloadTotal();
    }
  );

  $(document).on(
    'blur',
    '#billing_postcode, #billing_city, #billing_address_1, #shipping_postcode, #shipping_city, #shipping_address_1',
    function () {
      reloadTotal();
    }
  );

  function reloadTotal() {
    toggleCartLoader();

    const val = $('input[name="shipping_method"]:checked').val();
    const key = $('input[name="shipping_method"]:checked').prop('id');
    $('#shipping-method').val(val);
    $('#shipping-method-key').val(key);

    const billing_country = $('#billing_country').val();
    const billing_state = $('#billing_state').val();
    const billing_city = $('#billing_city').val();
    const billing_postcode = $('#billing_postcode').val();
    const billing_address_1 = $('#billing_address_1').val();
    const shipping_country = $('#other-recipient').is(':checked')
      ? $('#shipping_country').val()
      : $('#billing_country').val();
    const shipping_state = $('#other-recipient').is(':checked')
      ? $('#shipping_state').val()
      : $('#billing_state').val();
    const shipping_city = $('#other-recipient').is(':checked')
      ? $('#shipping_city').val()
      : $('#billing_city').val();
    const shipping_postcode = $('#other-recipient').is(':checked')
      ? $('#shipping_postcode').val()
      : $('#billing_postcode').val();
    const shipping_address_1 = $('#other-recipient').is(':checked')
      ? $('#shipping_address_1').val()
      : $('#billing_address_1').val();
    const shipping_method = $('#shipping-method').val();

    $.ajax({
      type: 'POST',
      url: sage.ajax_url,
      data: {
        action: 'loadCheckoutTotalSummary',
        nonce: sage.nonce,
        billing_country: billing_country,
        billing_state: billing_state,
        billing_city: billing_city,
        billing_postcode: billing_postcode,
        billing_address_1: billing_address_1,
        shipping_country: shipping_country,
        shipping_state: shipping_state,
        shipping_city: shipping_city,
        shipping_postcode: shipping_postcode,
        shipping_address_1: shipping_address_1,
        shipping_method: shipping_method,
      },
      dataType: 'json',
      success: function (res) {
        toggleCartLoader();
        $('#js-total-container').html(res.data.html);
      },
      error: function (e) {
        console.log(e);
      },
    });
  }

  if ($(window).width() >= 1280) {
    $(document).on('mouseenter', '.js-product-image', function () {
      const image = $(this).data('rollover');

      if (image != '') {
        $(this).fadeOut(0, function () {
          $(this).prop('src', image).fadeIn(140, 'linear');
        });
      }
    });

    $(document).on('mouseleave', '.js-product-image', function () {
      const image = $(this).data('image');
      if (image != '') {
        $(this).prop('src', image);
      }
    });
  }

  $(document).on('click', '.js-open-modal', function () {
    const name = $(this).data('modal');
    $('body').css('overflow', 'hidden');
    $('#js-' + name + '-modal').fadeIn(200);
  });

  $(document).on('click', '.js-close-modal', function () {
    const name = $(this).data('modal');
    $('body').css('overflow', 'auto');
    $('#js-' + name + '-modal').fadeOut(200);

    if (name == 'video') {
      stopAllIframe();
    }
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'Escape') {
      $('.js-close-modal').trigger('click');
    }
  });

  function stopAllIframe() {
    $('iframe').attr('src', $('iframe').attr('src'));
  }

  adjustNavTop();

  $(window).on('resize', function () {
    adjustNavTop();
  });

  let pElement = $('.woocommerce-order-details').prev('p');

  if (pElement) {
    pElement.addClass('bordered-red-text');
  }

  let myAccountPElement = $('#myaccount_new_method_form');

  // if(myAccountPElement){
  //     myAccountPElement.prev('p').prev('p').addClass('hello-text');
  //     let text = myAccountPElement.prev('p').prev('p').html();
  //     let modifiedText = text.replace(/\(/g, "-- ").replace(/\)/g, "");
  //     myAccountPElement.prev('p').prev('p').html(modifiedText);
  //     myAccountPElement.prev('p').addClass('bordered-red-text');
  // }

  $('.woocommerce-MyAccount-content header.title form')
    .find('br:first')
    .after('<br>');
});

function adjustNavTop() {
  if ($(window).width() < 1280) {
    var elementHeight = $('#main-header-content').outerHeight();
    $('nav').css('top', elementHeight + 'px');
  } else {
    $('nav').css('top', '');
  }
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  let name = cname + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function queryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = urlParams.get('category');
  if (!params) return;
  const category = params.split(';');
  let clickedTitle = false;
  if (category) {
    for (let i = 0; i < category.length; i++) {
      waitForElement('#category-' + category[i], 3000)
        .then(function () {
          const el = $('#category-' + category[i]);
          el.trigger('click');
          if (!clickedTitle) {
            $(
              '.desktop-side-filter aside ul:first li:first span:first'
            ).trigger('click');
            clickedTitle = true;
          }
        })
        .catch(() => {
          console.log('element did not load');
        });
    }
    if ($(window).width() >= 768) {
      $('#toggleSidebarBtn').trigger('click');
    }
  }
}

function waitForElement(querySelector, timeout) {
  return new Promise((resolve, reject) => {
    var timer = false;
    if (document.querySelectorAll(querySelector).length) return resolve();
    const observer = new MutationObserver(() => {
      if (document.querySelectorAll(querySelector).length) {
        observer.disconnect();
        if (timer !== false) clearTimeout(timer);
        return resolve();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    if (timeout)
      timer = setTimeout(() => {
        observer.disconnect();
        reject();
      }, timeout);
  });
}

$(window).on('load', function () {
  queryParams();

  $('.es_subscription_form')
    .find('input[name="esfpx_es_hp_email"]')
    .addClass(
      'w-full text-sm font-sohneMono border-b border-current text-current placeholder:text-current bg-transparent rounded-none'
    );

  $(window).on('resize', function () {
    if (
      !$('.menu-btn').hasClass('open') &&
      $('body').hasClass('overflow-hidden')
    ) {
      $('body').css('overflow', 'auto');
    }
  });

  function HeaderPush() {
    $('header').removeClass('block');
    $('header').addClass('fixed');
    const checker =
      $('.menu-btn').hasClass('open') && $('body').hasClass('overflow-hidden');
    let height = $('header').innerHeight();
    if (checker) {
      height = height - $('.hamburger_menu').innerHeight();
    }
    $('.main-content').css('paddingTop', height);
  }
});
//add lifestyle id
// Wait for the document to finish loading
document.addEventListener('DOMContentLoaded', function () {
  // Get the current URL
  var currentURL = window.location.href;

  // Check if the URL contains the segment "lifestyle"
  if (currentURL.indexOf('lifestyle') !== -1) {
    console.log('OK');

    // Find the first element with the class "woocommerce"
    var woocommerceElement = document.querySelector('.woocommerce');

    // Add the ID "lifestyle-page" to the element
    if (woocommerceElement) {
      woocommerceElement.setAttribute('id', 'merchandise-page');
    }
  }
});

// replace tax labels on successful checkout
//   if (window.location.href.indexOf("order-received") > -1) {
//     console.log("Updating tax labels..")
//     const orderTableDetails = document.getElementsByClassName("woocommerce-table--order-details")
//     let rows = orderTableDetails[0].rows
//     let taxCtr = 0;

//     if(rows.length > 0){
//         for (let i = 0; i < rows.length; i++) {
//             var  th = rows[i].firstElementChild

//             if(th.textContent == "Tax:"){
//                 taxCtr++;
//                 if(taxCtr == 1){
//                     th.innerHTML = "STATE TAX:"
//                 }
//                 if(taxCtr == 2){
//                     th.innerHTML = "SPECIAL TAX:"
//                 }
//                 if(taxCtr == 3){
//                     th.innerHTML = "CITY TAX:"
//                 }
//             }
//         }
//     }

//   }

function isCookieTrue(cookieName) {

    var cookies = document.cookie.split(';');
  
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf(cookieName + '=true') === 0) {
        return true;
      }
    }
  
    return false;
}


  function deleteCookie(cookieName) {
    document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }



